import type {
    ComposableOptionsBase,
    ProductAttrsGroupOption,
    ProductAttrsSkuOption,
    ProductAttrsGroupBase,
    ProductAttrsMaps,
    ProductAttrsMap,
    ProductAttrsValsMap,
    ProductOptionsModel,
    ProductOrderOptionAttrs
} from '~/types';

import { merge as lo_mergeCompat } from 'es-toolkit/compat';
import { mergeWith as lo_mergeWith } from 'es-toolkit';
import { tryArrayConcat } from 'x1-base/utils';
import {
    createSharedComposable
} from '@vueuse/core';

export interface UseProductAttrsOptions extends ComposableOptionsBase {}
export function useProductAttrsStandalone(options: Partial<UseProductAttrsOptions> = {}) {

    function processAttrsGroups(
        ...attrsGroup: ProductAttrsGroupBase[][]
    ): ProductAttrsMaps {
        const attrsMap: ProductAttrsMap = {};
        const attrsValsMap: ProductAttrsValsMap = {};

        attrsGroup.forEach((group) => {
            const _attrsMap: ProductAttrsMap = {};
            const _attrsValsMap: ProductAttrsValsMap = {};

            group.forEach((attr) => {
                const uid = attr.attribute.uid;
                const attrVals: string[] = [];
                
                attr.groupValues.forEach((skuOpt: ProductAttrsSkuOption) => {
                    const vUid = skuOpt.value.uid!;
                    _attrsValsMap[vUid] = uid;
                    attrVals.push(vUid);
                });

                _attrsMap[uid] = attrVals;
            });

            lo_mergeWith(attrsMap, _attrsMap, tryArrayConcat);
            lo_mergeCompat(attrsValsMap, _attrsValsMap);
        });

        return {
            attrs: attrsMap,
            attrsVals: attrsValsMap
        };
    }

    function getOrderedAttrsFromOptionsModel(
        optionsList: ProductAttrsGroupOption[],
        optionsModel: ProductOptionsModel
    ): ProductOrderOptionAttrs {
        return optionsList
            .map((o) => o.attribute.uid)
            .reduce((acc: ProductOrderOptionAttrs, attrUid) => {
                const val = optionsModel[attrUid];

                if (val) {
                    acc.attrs.push(attrUid);
                    acc.attrsVals.push(val);
                }

                return acc;
            }, {
                attrs: [],
                attrsVals: []
            }
        );
    }

    return {
        processAttrsGroups,
        getOrderedAttrsFromOptionsModel
    };
}

export const useProductAttrs = createSharedComposable(useProductAttrsStandalone);
